/* eslint-disable no-unused-vars */
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgVideo from 'lightgallery/plugins/video';
import lgZoom from 'lightgallery/plugins/zoom';
import PinchZoom from 'pinch-zoom-js';
import { isLG } from '../../util/domutils';
import videoPlayer from './videoPlayer';

export const GLOBALS = {
  PINCH_ZOOM: [],
  PINCH_ZOOM_TOGGLED: false,
  PLUGIN: null,
};

export const EVENTS = {
  PINCH_ZOOM_START: 'pinch-zoom:start',
  PINCH_ZOOM_END: 'pinch-zoom:end',
};

const SELECTORS = {
  GALLERY: '.primary-images__wrapper',
  IMAGE_WRAPPER: '.primary-images__image-wrapper',
  TOOLBAR: '.lg-toolbar',
  SLIDE: '.lg-item',
  MAIN_IMAGE: '.lg-image',
};

export const PDP_GALLERY_EVENTS = {
  OPEN: 'gallery:open',
};

const addMouseMoveEvent = (image) => {
  if (image) {
    image.style.top = '0';
    image.addEventListener('mousemove', (mouseEvent) => {
      const toolbar = document.querySelector(SELECTORS.TOOLBAR);

      const imgHeight = image.clientHeight;
      const windowHeight = window.outerHeight;
      const toolbarHeight = (toolbar && toolbar.clientHeight) || 0;
      const mouseY = mouseEvent.clientY - toolbarHeight;

      const verticalOffsetPercent = (mouseY / windowHeight) * 100;
      const imageOffset = (imgHeight / 100) * verticalOffsetPercent;
      const calculatedOffset = Math.min(imgHeight - windowHeight, imageOffset);

      image.style.top = `-${calculatedOffset}px`;
    });

    image.dataset.scrollInitialized = 'true';
  }
};

const handleZoomOutVideo = () => {
  const currentVideoSlide = document.querySelector('.lg-current .lg-video-cont');
  if (currentVideoSlide) {
    document.querySelector('.lg-video-cont').style.height = `${window.innerHeight
      - document.querySelector('.lg-thumb-outer').offsetHeight}px`;
  }
};

const initGallery = (container) => {
  const enableZoomControls = document.querySelector(SELECTORS.GALLERY).dataset.zoomControls;

  document.querySelectorAll(SELECTORS.IMAGE_WRAPPER).forEach((imageWrapper) => {
    imageWrapper.dataset.width = window.outerWidth;
  });

  // eslint-disable-next-line prefer-const
  let plugin = lightGallery(container, {
    plugins: [lgZoom, lgThumbnail, lgVideo],
    thumbnail: true,
    enableDrag: false,
    download: false,
    controls: false,
    actualSize: false,
    counter: false,
    autoplayVideoOnSlide: container.dataset.autoplayvideo === 'true',
    gotoNextSlideOnVideoEnd: container.dataset.gotonextslideonvideoend === 'true',
    zoomFromOrigin: false,
    vimeoPlayerParams: {
      controls: true,
      loop: container.dataset.playvideoinloop === 'true',
      autopause: true,
      autoPlay: container.dataset.autoplayvideo === 'true',
      responsive: true,
    },
  });

  container.addEventListener('lgBeforeOpen', () => {
    document.dispatchEvent(new CustomEvent(PDP_GALLERY_EVENTS.OPEN));
  });

  container.addEventListener('lgAfterOpen', () => {
    const maincontainer = document.querySelectorAll('.lg-container');
    if (maincontainer.length > 1) {
      maincontainer[0].remove();
    }
  });

  container.addEventListener('lgAfterSlide', () => {
    const zoomIn = document.querySelector('.lg #lg-zoom-in');
    if (zoomIn) {
      zoomIn.classList.remove('inactive');
    }
  });

  container.addEventListener('lgSlideItemLoad', () => {
    handleZoomOutVideo();
    const slides = document.querySelectorAll(`${SELECTORS.SLIDE}`);
    slides.forEach((slide) => {
      const image = slide && slide.querySelector(SELECTORS.MAIN_IMAGE);
      addMouseMoveEvent(image);
    });
  });

  container.addEventListener('lgAfterClose', () => {
    const videoEle = document.getElementById('product-video');
    if (videoEle && !videoEle.classList.contains('d-none')) {
      const playButton = document.querySelector('.play-button');
      if (playButton) {
        if (playButton.classList.contains('d-none')) {
          playButton.classList.remove('d-none');
        }
      }
    }
  });

  if (enableZoomControls === 'true') {
    container.addEventListener('lgAfterOpen', () => {
      const thumbnailArea = document.querySelector('.lg-thumb-outer .lg-thumb.group');
      const zoomIconsWrapper = document.createElement('div');
      const searchIcon = document.createElement('i');
      const zoomIcons = {
        out: document.querySelector('.lg #lg-zoom-out'),
        in: document.querySelector('.lg #lg-zoom-in'),
      };

      zoomIcons.in.classList.remove('lg-icon');
      zoomIcons.out.classList.remove('lg-icon');
      zoomIcons.in.classList.add('border', 'border-primary', 'font-icon', 'icon-plus', 'text-center', 'mx-4');
      zoomIcons.out.classList.add('border', 'border-primary', 'font-icon', 'icon-minus', 'text-center', 'mx-4');
      searchIcon.classList.add('lg-zoom-icon', 'font-icon', 'icon-fa-search');

      zoomIconsWrapper.classList.add('lg-toolbar-custom');
      zoomIconsWrapper.appendChild(zoomIcons.out);
      zoomIconsWrapper.appendChild(searchIcon);
      zoomIconsWrapper.appendChild(zoomIcons.in);

      thumbnailArea.appendChild(zoomIconsWrapper);

      zoomIcons.in.addEventListener('click', () => {
        const zoomLevel = document.querySelector('.lg-current .lg-image').dataset.scale;
        if (zoomLevel > 10) {
          zoomIcons.in.classList.add('inactive');
        } else {
          zoomIcons.in.classList.remove('inactive');
        }
      });

      zoomIcons.out.addEventListener('click', () => {
        zoomIcons.in.classList.remove('inactive');
      });
    });
  }
  return plugin;
};

const handlePinchZoom = (container) => {
  if (!container.dataset.initialized) {
    const images = container.querySelectorAll('img');

    images.forEach((imgElement) => {
      const pinchZoomObj = new PinchZoom(imgElement, {
        draggableUnzoomed: false,
        minZoom: 1,
        setOffsetsOnce: false,
        onZoomUpdate: (zoomObj) => {
          const zoomStart = zoomObj.zoomFactor > 1 && !GLOBALS.PINCH_ZOOM_TOGGLED;
          const zoomEnd = zoomObj.zoomFactor <= 1 && GLOBALS.PINCH_ZOOM_TOGGLED;
          if (zoomStart) {
            GLOBALS.PINCH_ZOOM_TOGGLED = true;
            document.dispatchEvent(new CustomEvent(EVENTS.PINCH_ZOOM_START));
          } else if (zoomEnd) {
            GLOBALS.PINCH_ZOOM_TOGGLED = false;
            document.dispatchEvent(new CustomEvent(EVENTS.PINCH_ZOOM_END));
          }
        },
      });
      GLOBALS.PINCH_ZOOM.push(pinchZoomObj);
    });

    container.dataset.initialized = 'true';
  } else if (GLOBALS.PINCH_ZOOM.length > 0) {
    GLOBALS.PINCH_ZOOM.forEach((pinchZoomObj) => {
      pinchZoomObj.update({ type: 'resize' });
      if (pinchZoomObj.el.classList.contains('product-video-slot')) {
        setTimeout(() => {
          handleZoomOutVideo();
        }, 0);
      }
    });
  }
};

export const initImageGallery = () => {
  const imgObj = document.querySelectorAll('.zoom-image');
  const videoButton = document.querySelector('.play-button');
  const container = document.querySelector(SELECTORS.GALLERY);
  let galleryId = container.getAttribute('lg-uid');
  const imageWrappers = container.querySelectorAll(SELECTORS.IMAGE_WRAPPER);
  GLOBALS.PLUGIN = lightGallery();

  if (isLG()) {
    imgObj.forEach((item) => {
      item.addEventListener('click', () => {
        if (GLOBALS.PLUGIN && GLOBALS.PLUGIN.items) {
          GLOBALS.PLUGIN.destroy();
          galleryId = false;
        }
        if (!galleryId) {
          GLOBALS.PLUGIN = initGallery(container);
        }
      });
    });
  } else if (!isLG() && galleryId && window.lgData && window.lgData[galleryId]) {
    GLOBALS.PLUGIN.destroy();
  }

  handlePinchZoom(container);
  if (videoButton) {
    videoButton.addEventListener('click', () => {
      if (isLG()) {
        if (GLOBALS.PLUGIN && GLOBALS.PLUGIN.items) {
          GLOBALS.PLUGIN.destroy();
        }
        GLOBALS.PLUGIN = initGallery(container);
      }
      videoPlayer();
    });
  }
};
